import React from 'react'
import { countBy } from 'lodash'

import Section from 'components/layout/content/section'
import { Item } from 'components/items'

import useQueryParams from 'lib/hooks/use-query-params'
import { filterHelper } from 'features/side-list/filter/filter-by-query-params'
import { useErrorsQuery, useAllResourcesQuery } from 'hooks/api'

import styles from './styles.module.less'

const ErroredResourcesList = () => {
  const { getValue: selected, setValue: setSelected } = useQueryParams('resource', [])

  const { isLoading, data: errors } = useErrorsQuery()
  const { isLoading: resourcesLoading, data: resources } = useAllResourcesQuery()

  const countByResources = countBy(errors, 'resource.id')

  const resourceItems = Object.keys(countByResources).map(id => {
    const count = countByResources[id]
    if (count <= 1) return null
    const resource = resources && resources[id]

    if (!resource) return null

    return ({
      ...resource,
      id,
      count,
      total: Object.keys(resources)?.length
    })
  })?.filter(item => item)

  return (
    <Section className={resourceItems?.length > 2 ? styles.wrapper_hide : ''} title='Resources' titleUpperCase loading={isLoading || resourcesLoading || !resources}>
      {resourceItems?.length !== 0
        ? resourceItems?.sort((a, b) => b.count - a.count)?.map(item => (
          <Item.Resource
            {...item}
            key={item?.id}
            onSelect={(item) => setSelected(filterHelper(item, selected))}
            selected={selected}
          />))
        : <p>No resources with more than one error was found</p>
      }
    </Section>
  )
}

export default ErroredResourcesList
